import React, { useCallback, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import Modal from 'components/Modal';
import Preloader from 'components/Preloader';

import { getSelection } from 'utils/helpers/selection';

const MisprintFormContainer = dynamic(
	() => import('containers/forms/Misprint'),
	{
		ssr: false,
		loading: () => <Preloader height="30vh" />
	}
);

const MisprintModal = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [currentSelection, setCurrentSelection] = useState(null);

	useEffect(() => {
		const keydownListener = (event) => {
			if (event.ctrlKey && event.key === 'Enter') {
				const selection = getSelection(window.getSelection());
				setCurrentSelection(selection);
				setIsOpen(true);
			}
		};

		document.addEventListener('keydown', keydownListener);

		return () => {
			document.removeEventListener('keydown', keydownListener);
		};
	}, []);

	const hideMisprintModal = useCallback(() => {
		setIsOpen(false);
	}, []);

	const resetSelection = useCallback(() => {
		setCurrentSelection(null);
	}, []);

	return (
		<Modal
			header="Ошибка на сайте"
			isShowModal={isOpen}
			onRequestClose={hideMisprintModal}
			onAfterClose={resetSelection}
			zIndex={150}
		>
			{currentSelection && (
				<MisprintFormContainer
					selection={currentSelection}
					onSubmitForm={hideMisprintModal}
				/>
			)}
		</Modal>
	);
};

export default MisprintModal;
